<div class="game" [style.background-image]="statesService.backgroundImageSrc">
</div>
